import React, { ReactNode } from "react";
import { SubHeader } from "src/components";
interface CounterLayoutProps {
  children: ReactNode;
}

const StockistBlockLayout: React.FC<CounterLayoutProps> = ({ children }) => {

  return (
    <div className="w-full">
      <SubHeader
        onAddNew={() => {
          // setShowAddEditForm(true);
        }}
      />
      {children}
    </div>
  );
};

export default StockistBlockLayout;
